import { Colors } from '@sigma-frontend-libs/commons'

import { buttonModes, icons, services } from '@/utils'

import button from '@/components/button'
import fileCard from '@/components/file/item/card'
import sticker from '@/components/sticker'
import date from '@/components/templates/service/item/date'
import owner from '@/components/templates/service/item/owner'

function renderFrom(h) {
  return h(
    sticker,
    {
      props: {
        value: this.value.from,
        label: this.getTranslate(`${services.sendings}.headers.from`),
        iconSVG: this.value.type,
        iconColor: Colors[this.value.type],
        iconTooltip: this.getTranslate(`${services.sendings}.types.${this.value.type}`),
        width: 130
      }
    }
  )
}

function renderText(h) {
  if (this.viewport.breakpoint.smUp) {
    if (this.value.payload.text) {
      return h(
        sticker,
        {
          props: {
            value: this.value.payload.text,
            label: this.getTranslate('sendings.headers.text'),
            icon: icons.text_snippet,
            color: Colors.grey,
            iconTooltip: this.getTranslate('sendings.headers.text')
          }
        }
      )
    }
  }
}

function renderRecipient(h) {
  if (this.value.payload.to) {
    return h(
      sticker,
      {
        props: {
          value: this.value.payload.to,
          label: this.getTranslate('sendings.headers.recipient'),
          icon: icons.person,
          color: Colors.grey,
          width: 140
        }
      }
    )
  }
}

function renderOwner(h) {
  if (this.viewport.breakpoint.smUp) {
    return h(
      owner,
      {
        props: {
          value: this.value,
          copy: true
        }
      }
    )
  }
}

function renderInfo(h) {
  return h(
    'div',
    {
      class: `${services.sendingsIncoming}__info`
    },
    [
      renderFrom.call(this, h),
      renderRecipient.call(this, h),
      renderOwner.call(this, h),
      renderText.call(this, h)
    ]
  )
}

function renderFileCard(h) {
  if (this.viewport.breakpoint.lgUp) {
    if (this.value.File) {
      return h(
        fileCard,
        {
          class: 'pa-0',
          props: {
            value: this.value.File,
            outline: false,
            displayMenu: false,
            flat: true,
            maxWidth: 300,
            small: true
          }
        }
      )
    }
  }
}

function renderSourceDataButton(h) {
  if (this.checkPermissions(`advanced.${services.sendingsIncoming}.get`)) {
    return h(
      button,
      {
        props: {
          icon: icons.code,
          mode: buttonModes.flat,
          color: Colors.primary
        },
        on: {
          click: () => {
            this.$emit('source', this.value)
          }
        }
      }
    )
  }
}

function renderCreatedAt(h) {
  if (this.viewport.breakpoint.lgUp) {
    return h(
      date,
      {
        props: {
          value: this.value
        }
      }
    )
  }
}

export default function(h) {
  return h(
    'div',
    {
      class: `service-template-item ${services.sendingsIncoming}__panel`
    },
    [
      renderInfo.call(this, h),
      renderFileCard.call(this, h),
      renderSourceDataButton.call(this, h),
      renderCreatedAt.call(this, h)
    ]
  )
}
